const FILES_PATH = '/files/';

const isBackFileUrl = (url: URL, backendUrl: string) =>
  url.href.startsWith(`${backendUrl}${FILES_PATH}`);

const withContext = (
  value: string,
  context: string,
  backendUrl: string,
): string => {
  const url = URL.canParse(value) ? new URL(value) : undefined;

  if (!url || !isBackFileUrl(url, backendUrl)) {
    return value;
  }

  url.searchParams.set('context', context);

  return url.href;
};

// The images and links of a content pointing to files of the back carry the read context: the
// master data files (images of their contents) are read within the mission showing them.
export const withFileReadContext = ({
  html,
  context,
  backendUrl,
}: Readonly<{
  html: string;
  context: string | undefined;
  backendUrl: string;
}>): string => {
  if (!context || !html.includes(FILES_PATH)) {
    return html;
  }

  const document = new DOMParser().parseFromString(html, 'text/html');

  document.querySelectorAll('img[src]').forEach((image) => {
    image.setAttribute(
      'src',
      withContext(image.getAttribute('src') ?? '', context, backendUrl),
    );
  });
  document.querySelectorAll('a[href]').forEach((link) => {
    link.setAttribute(
      'href',
      withContext(link.getAttribute('href') ?? '', context, backendUrl),
    );
  });

  return document.body.innerHTML;
};
